// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-radio-group[data-v-00400500]  .el-radio-button__inner:hover {\n  background-color: #fff;\n  color: var(--prev-color-primary) !important;\n}\n.time-radio-active[data-v-00400500]  .el-radio-button__inner {\n  background-color: #fff !important;\n  color: var(--prev-color-primary) !important;\n}", ""]);
// Exports
module.exports = exports;
